module.exports = __webpack_public_path__ + "static/media/welder-defectivesess-list.8e2d8a4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/welder-defectivesess-list.jpg
// module id = 1930
// module chunks = 0